// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".skeleton-cell {\n  padding: 14px 16px;\n}\n", ""]);
// Exports
module.exports = exports;
